import { Component } from '@angular/core';

@Component({
  selector: 'app-map-full-width',
  templateUrl: './map-full-width.component.html',
  styleUrls: [],
})
export class MapFullWidthComponent {}
